<template>
  <div class="page-header">
    <div class="header-content">
      <div class="header-left">
        <h1
          v-if="title"
          class="page-title"
        >
          {{ title }}
        </h1>
        <p
          v-if="description"
          class="page-description"
        >
          {{ description }}
        </p>
      </div>
      <div
        class="header-right"
        v-if="$slots.actions"
      >
        <slot name="actions" />
      </div>
    </div>
    <div
      v-if="$slots.extra"
      class="header-extra"
    >
      <slot name="extra" />
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  }
})
</script>

<style scoped lang="scss">
.page-header {
  margin-bottom: var(--spacing-xl);
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  padding: var(--spacing-xl);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
  transition: box-shadow var(--transition-base) var(--ease-out);
  position: relative;
  overflow: hidden;
  pointer-events: auto;
}

.page-header .header-content,
.page-header .header-extra {
  pointer-events: auto;
}

.page-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--panel-top-line);
  opacity: 0.9;
  pointer-events: none;
}

.page-header .header-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-lg);
}

.page-header .header-left {
  flex: 1;
}

.page-header .page-title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin: 0 0 var(--spacing-sm) 0;
  line-height: var(--line-height-tight);
}

.page-header .page-description {
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
  margin: 0;
  line-height: var(--line-height-loose);
}

.page-header .header-right {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  flex-shrink: 0;
}

.page-header .header-extra {
  margin-top: var(--spacing-lg);
  padding-top: var(--spacing-lg);
  border-top: 1px solid var(--color-border);
}

@media (max-width: 768px) {
  .page-header {
    padding: var(--spacing-lg);
  }

  .page-header .header-content {
    flex-direction: column;
  }

  .page-header .header-right {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
